var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-form",
    {
      ref: "ruleForm",
      attrs: {
        model: _vm.currentComponent,
        rules: _vm.rules,
        "label-width": "100px",
        isNeedRequire: "",
        isNeedTooltip: "",
        "label-position": "top",
      },
    },
    [
      _c(
        "yxt-form-item",
        {
          attrs: {
            label: _vm.$t("pc_biz_ote_lbl_questionstem"),
            rules: _vm.rulesContent,
            prop: "content",
            size: "small",
          },
        },
        [
          _c("common-attachment-textfield", {
            attrs: {
              content: _vm.currentComponent.content,
              "single-limit": "",
            },
            on: {
              "update:content": function ($event) {
                return _vm.$set(_vm.currentComponent, "content", $event)
              },
            },
          }),
        ],
        1
      ),
      _c("yxt-form-item", {
        staticClass: "mb0",
        attrs: { size: "small", label: _vm.$t("pc_biz_ote_lbl_options") },
      }),
      _c(
        "draggable",
        {
          attrs: {
            handle: ".moverHandle",
            chosenClass: "yxtbiz-ote-chosen-item",
            move: _vm.onMoveTarget,
          },
          on: {
            start: _vm.onStartTarget,
            clone: _vm.onCloneTarget,
            end: _vm.onEndTarget,
          },
          model: {
            value: _vm.currentComponent.questionItems,
            callback: function ($$v) {
              _vm.$set(_vm.currentComponent, "questionItems", $$v)
            },
            expression: "currentComponent.questionItems",
          },
        },
        _vm._l(_vm.currentComponent.questionItems, function (item, index2) {
          return _c(
            "yxt-form-item",
            {
              key: item.id,
              staticClass: "yxtbiz-ote-edit-ques-option",
              attrs: {
                rules: _vm.rulesItem,
                prop: "questionItems." + index2 + ".itemContent",
                size: "small",
              },
            },
            [
              _c(
                "div",
                { staticClass: "flex flex-mid wp-100" },
                [
                  _c(
                    "div",
                    { staticClass: "moverHandle flex flex-mid mr8" },
                    [
                      _c("yxt-svg", {
                        staticClass: "color-gray-7",
                        attrs: {
                          "remote-url": _vm.SvgMediaNewUrl,
                          width: "16px",
                          height: "16px",
                          "icon-class": "ai-drag-cc",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "mr8 min-w-16 text-center" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.convertASCII(index2)) +
                        "\n        "
                    ),
                  ]),
                  _c("common-attachment-textfield", {
                    staticClass: "flex-g-1",
                    attrs: {
                      "auto-focus": _vm.focusIndex === index2,
                      content: item.itemContent,
                      "single-limit": "",
                    },
                    on: {
                      "update:content": function ($event) {
                        return _vm.$set(item, "itemContent", $event)
                      },
                    },
                  }),
                  _c(
                    "yxt-tooltip",
                    {
                      attrs: {
                        content: _vm.$t("pc_biz_ote_btn_delete"),
                        placement: "top",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "yxtbiz-ote-ai-icon hand ml12",
                          on: {
                            click: function ($event) {
                              return _vm.delItem(index2)
                            },
                          },
                        },
                        [
                          _c("yxt-svg", {
                            attrs: {
                              width: "16px",
                              height: "16px",
                              "icon-class": "delete",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          )
        }),
        1
      ),
      _c(
        "div",
        { staticClass: "mb24" },
        [
          _c(
            "yxt-button",
            {
              attrs: {
                type: "text",
                disabled:
                  _vm.currentComponent.questionItems &&
                  _vm.currentComponent.questionItems.length >= 12,
              },
              on: {
                click: function ($event) {
                  return _vm.addItem()
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "ml48 flex flex-mid" },
                [
                  _c("yxt-svg", {
                    staticClass: "mr4",
                    attrs: {
                      width: "16px",
                      height: "16px",
                      "icon-class": "common_plus",
                    },
                  }),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("pc_biz_ote_btn_additem"))),
                  ]),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "yxt-form-item",
        {
          attrs: {
            label: _vm.$t("pc_biz_ote_lbl_itemanswer"),
            prop: "answer",
            size: "small",
          },
        },
        [
          _c(
            "yxt-checkbox-group",
            {
              on: { change: _vm.radioChange },
              model: {
                value: _vm.currentComponent.answer,
                callback: function ($$v) {
                  _vm.$set(_vm.currentComponent, "answer", $$v)
                },
                expression: "currentComponent.answer",
              },
            },
            _vm._l(_vm.currentComponent.questionItems, function (item, index) {
              return _c(
                "yxt-checkbox",
                { key: item.id, attrs: { label: item.id, name: "type" } },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.convertASCII(index)) + "\n      "
                  ),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "yxt-form-item",
        {
          attrs: {
            label: _vm.$t("pc_biz_ote_lbl_quesanalyze"),
            size: "small",
            prop: "explainText",
          },
        },
        [
          _c("common-attachment-textfield", {
            attrs: {
              content: _vm.currentComponent.explainText,
              "single-limit": "",
            },
            on: {
              "update:content": function ($event) {
                return _vm.$set(_vm.currentComponent, "explainText", $event)
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }